import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { SimulateAllState } from 'store/modules/simulate_all_store/types';
import { getPackageService } from 'store/modules/get_package_service_store/actions';
import { ParcelamentoServicesState } from 'store/modules/get_package_service_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import LoaderPayment from '../loader_payment';

interface SubscriptionSummaryProps {
  paymentType: string;
  dadosPlanCheckout: any;
  setParcelas: React.Dispatch<React.SetStateAction<object | null>>;
  setParcelaValorFinal: React.Dispatch<React.SetStateAction<string>>;
  setParcelaCheckout: React.Dispatch<React.SetStateAction<boolean>>;
  setParcelaRequest: React.Dispatch<React.SetStateAction<number>>;
}

const SubscriptionSummary = (props: SubscriptionSummaryProps) => {
  const {
    paymentType,
    dadosPlanCheckout,
    setParcelas,
    setParcelaValorFinal,
    setParcelaCheckout,
    setParcelaRequest,
  } = props;
  const dispatch = useDispatch();
  const [servicosId, setServicosId] = useState<Array<any>>([]);
  const [typePayment, setTypePayment] = useState<string>('card');

  const { simulate_all, request } = useSelector<ApplicationState, SimulateAllState>(
    (state) => state.session.simulate_all,
  );
  const { parcelamento } = useSelector<ApplicationState, ParcelamentoServicesState>(
    (state) => state.session.parcelamento,
  );
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    const extractServicosId = () => {
      return simulate_all?.original?.[typePayment]?.[
        simulate_all?.package_name
      ]?.original?.servicos?.map((servico) => ({
        servico_id: servico.id,
        plano_id: simulate_all?.plan_id,
        status_id: 1,
        porcentagem_adicional: 0,
      }));
    };

    setServicosId(extractServicosId());
  }, [simulate_all, typePayment]);

  useEffect(() => {
    setTypePayment(paymentType === 'cartao' ? 'card' : 'invoice');
  }, [paymentType]);

  useEffect(() => {
    const fetchData = async () => {
      if (servicosId?.length > 0) {
        setParcelas(parcelamento?.parcelas);
        setParcelaValorFinal(String(parcelamento?.valor_final));
        setParcelaCheckout(false);
        setParcelaRequest(200);

        await dispatch(
          getPackageService({
            paymentType: paymentType === 'cartao' ? 10 : 1,
            servicosId,
            renewal: panel?.renewal_plans,
          }),
        );
      }

      if (dadosPlanCheckout?.layout === 'checkout') {
        setParcelas(dadosPlanCheckout?.income_value);
        setParcelaValorFinal(dadosPlanCheckout?.selected_package[0]?.sale?.valor_total);
        setParcelaCheckout(true);
        setParcelaRequest(200);
      }
    };

    fetchData();
  }, [servicosId, paymentType]);

  return (
    <div className="position-fixed">
      <h2 className="font-weight-bolder mb-3">Resumo da assinatura</h2>
      <div className="card" style={{ borderRadius: '20px' }}>
        <div className="card-body">
          {request.loading ? (
            <div>
              <LoaderPayment />
            </div>
          ) : (
            <div>
              <div className="row">
                <div className="col-sm-7 card-text">
                  {dadosPlanCheckout?.layout === 'checkout' && dadosPlanCheckout?.package_name
                    ? dadosPlanCheckout.package_name[0].toUpperCase() +
                      dadosPlanCheckout.package_name.slice(1).toLowerCase()
                    : simulate_all?.package_name
                    ? simulate_all.package_name[0].toUpperCase() +
                      simulate_all.package_name.slice(1).toLowerCase()
                    : null}
                </div>

                <div className="col-sm-5 d-flex justify-content-end">
                  {dadosPlanCheckout
                    ? `R$ ${parseFloat(dadosPlanCheckout?.selected_package[0]?.sale?.valor_total)
                        .toFixed(2)
                        .replace('.', ',')}`
                    : simulate_all?.original?.invoice?.[
                        simulate_all?.package_name
                      ]?.original?.valor_final.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                </div>
              </div>
              <hr />
              {!dadosPlanCheckout && (
                <div className="row">
                  <div
                    className={`col-sm-8 card-text ${
                      paymentType === 'cartao' ? 'd-block' : 'd-none'
                    }`}
                  >
                    <span className="font-weight-bold text-danger">Desconto</span>
                  </div>
                  <div
                    className={`col-sm-4 font-weight-bold text-danger ${
                      paymentType === 'cartao' ? 'd-block' : 'd-none'
                    }`}
                  >
                    {simulate_all?.original?.[typePayment][
                      simulate_all?.package_name
                    ]?.original?.valor_variacao_forma_pagamento.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </div>
                </div>
              )}
              {!dadosPlanCheckout && (
                <hr className={`${paymentType === 'cartao' ? 'd-block' : 'd-none'}`} />
              )}
              <div className="row">
                <div className="col-sm-6">
                  <h3 className="font-weight-bold ">Total</h3>
                </div>
                <div className="col-sm-6 text-center">
                  <h4 className="font-weight-bold">
                    {dadosPlanCheckout
                      ? `R$ ${parseFloat(dadosPlanCheckout?.selected_package[0]?.sale?.valor_total)
                          .toFixed(2)
                          .replace('.', ',')}`
                      : request.loaded &&
                        simulate_all?.original?.[typePayment][
                          simulate_all?.package_name
                        ]?.original?.valor_final?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                  </h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSummary;
